import React from "react";
import MiscNavBar from "./MiscNavBar";

const Careers = () => {
  return (
    <>
      <MiscNavBar />
      <div className="flex items-center justify-center h-screen">
        <div className="pp-container text-center">
          <h1>Careers</h1>
          <br />
          <br />
         
          
          <p>Currently there are no openings! Stay tuned for new opportunities😊</p>
        </div>
      </div>
    </>
  );
};

export default Careers;
